import React from "react";
import PropTypes from "prop-types";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Card, CardImg, CardBody, Badge, CardTitle } from "reactstrap";
import { Link } from "react-router-dom";
import "../../assets/styles/card.scss";

const TeacherCard = ({ title, name, labels, tags, img, targetPath }) => {
  return (
    <Card className="teacher-card">
      <span className="card-top-text">{name}</span>
      <div className="cardimg-container">
        <Link to={targetPath}>
          <CardImg
            top
            className="teacher-img"
            width="100%"
            src={require("../../assets/img/teachers/" + img)}
            alt=" "
          />
        </Link>
      </div>
      <CardBody>
        {/* <div className="card-between">
          {labels &&
            labels.map((label) => (
              <Badge key={label} className="card-badge" color="light">
                {label}
              </Badge>
            ))}
        </div> */}
        <CardTitle>{title}</CardTitle>
        <div>
          {labels.map((label) => {
            return (
              <ul className="teacher-tags">
                <li>{label}</li>
              </ul>
            );
          })}
        </div>
        {/* <div>
          {tags &&
            tags.map((tag) => (
              <Badge key={tag} className="card-pill" color="light" pill>
                {tag}
              </Badge>
            ))}
        </div> */}
      </CardBody>
    </Card>
  );
};

TeacherCard.propTypes = {
  title: PropTypes.string.isRequired,
  category: PropTypes.string,
  description: PropTypes.string.isRequired,
  labels: PropTypes.arrayOf(PropTypes.string),
  tags: PropTypes.arrayOf(PropTypes.string),
  buttonText: PropTypes.string,
  img: PropTypes.string.isRequired,
};

TeacherCard.defaultProps = {
  category: "",
  labels: [],
  tags: [],
  buttonText: "사전예약",
};

export default TeacherCard;
